import * as React from 'react';
import * as ToastPrimitive from '@radix-ui/react-toast';
import clsx from 'clsx';
import { CheckCircleIcon, ExclamationCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';

function ToastRoot({ children, variant = 'success', ...props }) {
  return (
    <ToastPrimitive.Root
      {...props}
      className={clsx(
        'p-4',
        'shadow-lg rounded-lg bg-white',
        'border border-gray-100',
        'radix-state-open:animate-toast-slide-in-right',
        'radix-state-closed:animate-toast-hide',
        'radix-swipe-direction-right:radix-swipe-end:animate-toast-swipe-out-x',
        'radix-swipe-direction-right:translate-x-radix-toast-swipe-move-x',
        'radix-swipe-direction-down:radix-swipe-end:animate-toast-swipe-out-y',
        'radix-swipe-direction-down:translate-y-radix-toast-swipe-move-y',
        'radix-swipe-cancel:translate-x-0 radix-swipe-cancel:duration-200 radix-swipe-cancel:ease-[ease]',
        'focus:outline-none focus-visible:ring-3 focus-visible:ring-purple-500',
      )}
    >
      <div className={clsx('flex flex-row gap-x-2 items-start', {})}>
        <div className="mt-0.5">
          {variant === 'success' && <CheckCircleIcon className="h-5 w-5 text-green-500" />}

          {variant === 'alert' && <ExclamationCircleIcon className="h-5 w-5 text-orange-500" />}

          {variant === 'error' && <XCircleIcon className="h-5 w-5 text-red-500" />}
        </div>
        <div>{children}</div>
      </div>
    </ToastPrimitive.Root>
  );
}

function ToastTitle({ children, ...props }) {
  return (
    <ToastPrimitive.Title {...props} className={clsx('font-bold text-black')}>
      {children}
    </ToastPrimitive.Title>
  );
}

function ToastDescription({ children, ...props }) {
  return (
    <ToastPrimitive.Description {...props} className={clsx('text-gray-700')}>
      {children}
    </ToastPrimitive.Description>
  );
}

function ToastAction({ children, ...props }) {
  return (
    <ToastPrimitive.Action
      {...props}
      className={clsx(
        'inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500',
      )}
    >
      {children}
    </ToastPrimitive.Action>
  );
}

const Toast = ToastRoot;
Toast.Title = ToastTitle;
Toast.Description = ToastDescription;
Toast.Action = ToastAction;

export default Toast;
